import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { SheetKinds } from '../redux/sheetDbSlice';

const useCurrentSheetDb = () : {id: string, name: string, sheetKind: SheetKinds} | undefined => {
  const sheetDb = useSelector((state: RootState) => state.sheetDb);
  const id = sheetDb.currentSheetId;
  if (id) {
    const currentSheet = sheetDb.sheets[id];
    return {id: id, ...currentSheet};
  } else return undefined;
}

export default useCurrentSheetDb;
